import { ReactSVG } from 'react-svg';
import { RowView } from '../../components';
import AuthWrapper from '../../components/AuthWrapper';
import EligibleAccountsFunctional from './index.function';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import Loader from '../../components/Loader';
import ViewItems from '../../components/ViewItems';
import Button from '../../components/Button';
import images from '../../constants/images';
import Language from '../../components/Language';
import { cn } from '../../utils/utils';
import icons from '../../constants/icons';
import AccountCard from '../../components/AccountCard';

const EligibleAccounts = () => {
  const { isArabic, TextWeight, direction, eligibleAccounts, onPressApplication, eligible_accounts_loading, getContentKey, navigate } =
    EligibleAccountsFunctional();

  return (
    <AuthWrapper>
      <div className='w-full'>
        <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')} onClick={() => navigate(-1)} />
        <RowView className='justify-between items-center mt-10'>
          <img src={images.textLogo} width={70} />
          <div className="flex justify-end">
            <Language isLogin />
          </div>
        </RowView>

        <Text
          text={getContentKey('eligible_accounts_heading')}
          align={isArabic ? 'text-right' : 'text-left'}
          weight={TextWeight.semiBold}
          size={fontSizes.h18}
          className={'block mt-2'}
        />
        <div dir={direction} className='max-h-[450px] overflow-auto mt-4 space-y-4'>
          <AccountCard
            loading={eligible_accounts_loading}
            data={eligibleAccounts}
            onPressApplication={onPressApplication}
          />
        </div>
      </div>
    </AuthWrapper>
  );
};

export default EligibleAccounts;
